export interface PaginationRangeInput {
    currentPage: number;
    totalPages: number;
    total: number;
    itemsOnPage: number;
    pageSize?: number;
}

export function getPaginationItemRange({
    currentPage,
    totalPages,
    total,
    itemsOnPage,
    pageSize,
}: PaginationRangeInput): { start: number; end: number } {
    if (total === 0 || itemsOnPage === 0) {
        return { start: 0, end: 0 };
    }

    const resolvedPageSize =
        pageSize ??
        (currentPage < totalPages
            ? itemsOnPage
            : totalPages > 1
              ? Math.ceil((total - itemsOnPage) / (totalPages - 1))
              : itemsOnPage);

    const start = (currentPage - 1) * resolvedPageSize + 1;
    const end = Math.min(start + itemsOnPage - 1, total);

    return { start, end };
}
